interface CardFieldProps {
  label: string;
  value: string | number;
}

export function CardField({ label, value }: CardFieldProps) {
  const displayValue = !value ? 'null' : value;

  return (
    <div className="grid max-w-100 grid-cols-[auto_1fr] gap-x-1 text-xs">
      <span className="font-bold">{label}:</span>
      <p className="text-wrap wrap-anywhere">{displayValue}</p>
    </div>
  );
}
